// BookTickets/components/HelpBox/index.tsx
'use client'

import { useState } from 'react'
import cn from 'classnames'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

import styles from './index.module.scss'
import shared from '@booking/index.module.scss'

import { Modal } from '@booking/components/Modal'
import MobilityIcon from './assets/mobility.svg'
import MailIcon from './assets/mail.svg'
import { useBookingState } from '../../state/booking.context'

type HelpBoxProps = {
  email?: string
}

export default function HelpBox({ email = 'info@lisbonquake.com' }: HelpBoxProps) {
  const t = useTranslations('booking')
  const { config } = useBookingState()
  const [open, setOpen] = useState(false)
  const [secondaryOpen, setSecondaryOpen] = useState(false)

  const helpTitle = t('help.title')
  const mobilityLabel = t('help.mobility')

  const modalTitle = t('mobility.help')
  const modalHtml = t.raw('mobility.text')
  const linkHref = t('mobility.link')
  const linkText = t('mobility.linkText')

  return (
    <div className={cn(styles.box)}>
      {/* Mobility Modal */}
      <Modal modalIsOpen={open} setModalIsOpen={setOpen} className={cn(styles.modal)}>
        <h3>{modalTitle}</h3>

        {/* Translation contains HTML */}
        <div dangerouslySetInnerHTML={{ __html: modalHtml }} className="mb-4" />

        <Link href={linkHref} target="_blank" className={cn(shared.button)}>
          {linkText}
        </Link>
      </Modal>

      <h2 className={cn(styles.title)}>{helpTitle}</h2>

      {/* Mobility help trigger */}
      {config.text.helpBoxKey ? (
        <>
          <Modal
            modalIsOpen={secondaryOpen}
            setModalIsOpen={setSecondaryOpen}
            className={cn(styles.modal)}
          >
            <h3>{modalTitle}</h3>
            <div
              dangerouslySetInnerHTML={{ __html: t.raw(`${config.text.helpBoxKey}.content`) }}
              className="mb-4"
            />
            <Link
              href={t(`${config.text.helpBoxKey}.link`)}
              target="_blank"
              className={cn(shared.button)}
            >
              {linkText}
            </Link>
          </Modal>
          <div className={cn(styles.item)}>
            <MobilityIcon className={cn(styles.icon)} />
            <button type="button" onClick={() => setSecondaryOpen(true)}>
              {`${t(`${config.text.helpBoxKey}.label`)}`} - {mobilityLabel}
            </button>
          </div>
        </>
      ) : (
        <></>
      )}

      {/* Mobility help trigger */}
      <div className={cn(styles.item)}>
        <MobilityIcon className={cn(styles.icon)} />
        <button type="button" onClick={() => setOpen(true)}>
          {config.text.helpBoxKey ? 'Quake - ' : ''}
          {mobilityLabel}
        </button>
      </div>

      {/* Email */}
      <div className={cn(styles.item)}>
        <MailIcon className={cn(styles.icon)} />
        <a href={`mailto:${email}`}>{email}</a>
      </div>
    </div>
  )
}
